import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';

// Extended Appiya Component
import CasesGrid from './components-cases/CasesGrid';

const CasesPage = () => {
  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title="導入事例"
        subtitle="私たちの提供するスピードと価値は、お客様の成功によって初めて証明されます"
        breadcrumb="事例"
      />

      {/* 事例詳細 - Appiyaコンポーネント使用 */}
      <CasesGrid data={protoaiData.cases} />
    </div>
  );
};

export default CasesPage;